import type { ColoradoPrivateResidenceDeliveryRejectReason } from "@the-drop/types";

/** User-facing copy for checkout when an address fails MED private-residence checks. */
export function coloradoPrivateResidenceRejectMessage(
  reason: ColoradoPrivateResidenceDeliveryRejectReason | string,
): string {
  switch (reason) {
    case "out_of_state":
      return "Delivery is only available to Colorado addresses.";
    case "po_box":
      return "Colorado rules require delivery to a physical private residence. PO boxes are not accepted.";
    case "school_or_campus_in_address":
      return "Cannabis cannot be delivered to schools, universities, hospitals, libraries, or government buildings. Use a private residence.";
    case "commercial_mail_location":
      return "Use a residential street address. Mailbox stores, hotels, offices, and similar locations are not accepted for delivery.";
    default:
      return "This delivery address is not accepted. Enter a Colorado private residence.";
  }
}
